module.exports = __webpack_public_path__ + "static/media/Amber.6f0ef401.png";